import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const equipmentByComponent = createAsyncThunk('equipmentByComponent', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            // url: process.env.REACT_APP_API_URL + `equipment_by_component/${id}`,
            url: process.env.REACT_APP_API_URL + `equipment_assignment_by_component/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const equipmentByComponentSlice = createSlice({
    name: 'equipmentByComponent',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(equipmentByComponent.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(equipmentByComponent.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default equipmentByComponentSlice.reducer;